import React, { useEffect, useState, useMemo } from "react";
import SectionHeader from "../../common/sectionTitle";
import { orderStatus } from "../../../common/function/shopping";

const AFTER_STATUS_KEYS = ["CANCELLED", "RETURNED", "REFUNDED"];

const GROUPED_STATUS = {
  "상품 준비 중": ["CONFIRMED", "PREPARING"],
  "주문 완료": ["DELIVERED", "COMPLETED"],
};

const OrderStatus = ({ data }) => {
  const [rawStatuses, setRawStatuses] = useState([]);

  useEffect(() => {
    if (!data?.orders) return;

    const statuses =
      data.orders.flatMap((order) => order?.subOrders?.map((sub) => sub.status)) || [];

    setRawStatuses(statuses);
  }, [data]);

  // statusCounts: 상태별 개수
  const statusCounts = useMemo(() => {
    return rawStatuses.reduce((acc, status) => {
      acc[status] = (acc[status] || 0) + 1;
      return acc;
    }, {});
  }, [rawStatuses]);

  // 그룹화된 상태 키들
  const groupedKeys = useMemo(() => Object.values(GROUPED_STATUS).flat(), []);

  // 그룹 상태 처리
  const groupedStatuses = useMemo(() => {
    return Object.entries(GROUPED_STATUS).map(([label, keys]) => ({
      label,
      count: keys.reduce((sum, key) => sum + (statusCounts[key] || 0), 0),
    }));
  }, [statusCounts]);

  // 개별 상태 처리 (그룹/after 제외)
  const remainingStatuses = useMemo(() => {
    return Object.entries(orderStatus)
      .filter(([key]) => !AFTER_STATUS_KEYS.includes(key) && !groupedKeys.includes(key))
      .map(([key, label]) => ({
        label,
        count: statusCounts[key] || 0,
      }));
  }, [statusCounts, groupedKeys]);

  // 최종 상태 목록
  const statuses = useMemo(() => {
    return [...remainingStatuses, ...groupedStatuses];
  }, [remainingStatuses, groupedStatuses]);

  // 사후 처리 상태
  const afterStatuses = useMemo(() => {
    return Object.entries(orderStatus)
      .filter(([key]) => AFTER_STATUS_KEYS.includes(key))
      .map(([key, label]) => ({
        label: label.replace(" 완료", ""),
        count: statusCounts[key] || 0,
      }));
  }, [statusCounts]);

  return (
    <>
      <SectionHeader
        title="나의 주문처리 현황"
        subtitle={{
          label: "최근 6개월 기준",
        }}
      />
      <div className="statuses">
        {statuses.map((status) => (
          <div key={status.label}>
            <span>{status.label}</span>
            <strong>{status.count}</strong>
          </div>
        ))}
      </div>

      <div className="afterStatuses">
        {afterStatuses.map((status) => (
          <div key={status.label}>
            <span>{status.label}</span>
            <strong>{status.count}</strong>
          </div>
        ))}
      </div>
    </>
  );
};

export default OrderStatus;
